import Icon from '../SocialMediaIcons';
import styles from './Share.module.sass';
import { shareIconsData } from './shareIconsData';

const Share = ({ title, uri }) => {
    const shareData = shareIconsData(title, uri);

    return (
        <div className="post-content-right mt-16 text-right">
            <div className={`${styles.socialMedias} mx-auto mt-0 mb-16 flex w-fit max-w-[360px] flex-row justify-between text-center text-[#999] print:hidden`}>
                <span className="pr-2">Share:</span>
                {shareData.map((icon, index) => {
                    const { platform, url } = icon;
                    return (
                        <div className="mx-auto my-auto w-8" key={index}>
                            <Icon platform={platform} url={url} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Share;
